import React from "react";
import { AdminPortal } from "./components/AdminPortal";

function App() {
  return <AdminPortal />;
}

export default App;
